import React from 'react';
import { Routes, Route } from 'react-router-dom';
import QRCodeAuth from './QRCodeAuth';
import PaymentComplete from './PaymentComplete';
import PaymentFailure from './PaymentFailure';
import PaymentProcessing from './PaymentProcessing';

const PaymentProcessNaked: React.FC = () => {
  return (
    <Routes>
      <Route path="/qrcode-auth" element={<QRCodeAuth />} />
      <Route path="/processing" element={<PaymentProcessing />} />
      <Route path="/complete" element={<PaymentComplete />} />
      <Route path="/failure" element={<PaymentFailure />} />
    </Routes>
  );
};

export default PaymentProcessNaked;
